import aiWinPct from "../../../backend/app/reference/ai_win_pct.json";
import behaviorPercentiles from "../../../backend/app/reference/behavior_percentiles.json";
import colorScales from "../../../backend/app/reference/color_scales.json";
import cropRemoval from "../../../backend/app/reference/crop_removal.json";
import kFixation from "../../../backend/app/reference/k_fixation.json";
import modelGains from "../../../backend/app/reference/model_gains.json";
import statePrices from "../../../backend/app/reference/state_prices.json";
import zonePresets from "../../../backend/app/reference/zone_presets.json";

/**
 * The documents the browser calculations read. These are the same files
 * `GET /api/reference/{name}` serves. Importing them here puts the values in
 * the bundle, so module-load computations see them without a runtime fetch.
 */
export const BUNDLED_REFERENCE = {
  "crop-removal": cropRemoval,
  "zone-presets": zonePresets,
  "k-fixation": kFixation,
  "behavior-percentiles": behaviorPercentiles,
  "color-scales": colorScales,
  "state-prices": statePrices,
  "ai-win-pct": aiWinPct,
  "model-gains": modelGains,
} as const;
